import { REWARD_MACHINE_WELCOME_KEY } from './constants';

export const getLocalStorageRewardsMachineWelcome = (): string | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    return localStorage.getItem(REWARD_MACHINE_WELCOME_KEY);
};

export const setLocalStorageRewardsMachineWelcome = (value: boolean): void => {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.setItem(REWARD_MACHINE_WELCOME_KEY, String(value));
};
